import React, { useState, useEffect, useRef, useContext } from 'react'
import { useForm } from 'react-hook-form'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import FileUploader from '../../../dpe-usco/components/FileUploader/FileUploader'
import { LanguageContext } from '../../../services/context'
import { getLanguageByCompany } from '../../../services/apiHelper'

const UploadLegalFiles = ({ returnData, initialTemplateInfo, company_id, updateLegalFile }) => {
  const { register, handleSubmit } = useForm()
  const langData =  useContext(LanguageContext)
  const [companyLang, setCompanyLang] =  useState([])

  const canceled = useRef(false)
  useEffect(() => {
    return () => {
      canceled.current = true
    }
  }, [])

  useEffect(() => {
    getLanguageByCompany(company_id, langData).then(obj => {
      setCompanyLang(obj)
    })
  }, [company_id, langData])

  const onSubmit = values => {
    returnData(values)
  }

  const prevtemplate = lang => {
    if(initialTemplateInfo?.length > 0) {
      const index = initialTemplateInfo.findIndex(x => x.template_language === lang.lang_value)
      if(index !== -1)
      {
        return initialTemplateInfo[index].template_name
      }
    } 
    return false
  }

  const onFilesAdded = (files, lang_value) => {
    return new Promise(resolve => {
      const fileToLoad = files[0]
      const fileReader = new FileReader()
      let base64
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result
        const index = base64.indexOf(',')
        base64 = base64.slice(index + 1, base64.length)
        if (!canceled.current) {
          updateLegalFile({
            template_base64: base64,
            template_name: fileToLoad.name,
            template_language: lang_value
          })
        }
      }
      fileReader.onloadend = () => {
        resolve()
      }
      fileReader.readAsDataURL(fileToLoad)
    })
  }

  return (
    <Widget title="Upload legal files">
      <form onSubmit={handleSubmit(onSubmit)}>
        {companyLang.map((lang, index) => {
          return(
            <div key={index}>
              {prevtemplate(lang) && (
                <>
                  <p className="df jcfs mb0 pl0">{lang.lang_name} Previous Version:</p>
                  <p className="df jcfs fz14 mt0 pl0">{prevtemplate(lang)}</p>
                </>
              )}
              <div className="mb20 w100%">
                <label className="df mb10" htmlFor="scheduleOneFile">
                  {lang.lang_name} Master Agreement*
                </label>
                <div className="w45%">
                  <FileUploader
                    id={`fileUpload ${lang.lang_value}`}
                    theRef={register()}
                    buttonText="Choose file"
                    onFilesAdded={e => onFilesAdded(e, lang.lang_value)}
                  />
                </div>
              </div>
            </div>
          )
         
        })}
      </form>
    </Widget>
  )
}

export default UploadLegalFiles
